import { Stack, Box, Paper, Typography, Divider } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  totalPages: {
    id: 'autoCuration.pdfSplitEditor.totalPages',
    defaultMessage: 'Total Pages',
  },
  groups: {
    id: 'autoCuration.pdfSplitEditor.groups',
    defaultMessage: 'Groups',
  },
});
interface SummaryStatsProps {
  pageGroups: number[][];
}

export const SummaryStats = ({ pageGroups }: SummaryStatsProps) => {
  const { formatMessage } = useIntl();
  const { totalPages, totalGroups } = React.useMemo(() => {
    const totalPages = pageGroups.flat().length;
    const totalGroups = pageGroups.filter((g) => g.length > 1).length;
    return { totalPages, totalGroups };
  }, [pageGroups]);

  return (
    <Paper variant="outlined" sx={{ p: 1.5, mb: 2, bgcolor: 'primary.50' }}>
      <Stack direction="row" spacing={2} justifyContent="space-around">
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" color="primary.main">
            {totalPages}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {formatMessage(messages.totalPages)}
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" color="primary.main">
            {totalGroups}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {formatMessage(messages.groups)}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};
